// @flow
import type { Element } from 'react';

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '#components/pages/Components/Dashboard/index.jsx';
import Models from '#components/pages/Components/Models/Models.jsx';
import Component from '#components/pages/Components/Component/index.js';
import { COMPONENT_UUID, MODELS } from '#constants/pathStrings.js';

const Components = (): Element<typeof Routes> => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path={`:${COMPONENT_UUID}/`} element={<Dashboard />} />
    <Route path={`:${COMPONENT_UUID}/*`} element={<Component />} />
    <Route path={`${MODELS}/*`} element={<Models />} />
    <Route path="*" element={<Dashboard />} />
  </Routes>
);

export default Components;
